module.exports = __webpack_public_path__ + "static/img/MT.b7b7c1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/MT.jpg
// module id = 7k+G
// module chunks = 52